import React from 'react';
import { Helmet } from 'react-helmet';

const StructuredData = ({ 
  type = 'Organization',
  name = 'BC Surface Supply',
  description = 'BC Surface Supply offers premium Countertops, Sinks, and Cabinets in the greater Midwest.',
  address = {
    streetAddress: '123 Main St',
    addressLocality: 'Fort Wayne',
    addressRegion: 'IN',
    postalCode: '46802',
    addressCountry: 'US'
  },
  telephone = '+1-260-123-4567',
  url = 'https://bcsurfacesupply.com',
  logo = 'https://bcsurfacesupply.com/assets/logo.png',
  // New props for product-specific structured data
  productData = null,
  productType = null
}) => {
  let structuredData;

  if (productData && productType) {
    // Product-specific structured data
    structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: productData.name,
      description: productData.description,
      brand: {
        '@type': 'Brand',
        name: productData.brand || 'BC Surface Supply'
      },
      category: productType,
      image: productData.image,
      offers: {
        '@type': 'Offer',
        price: productData.price,
        priceCurrency: 'USD',
        availability: productData.inStock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
        seller: {
          '@type': 'Organization',
          name: 'BC Surface Supply',
          url: 'https://bcsurfacesupply.com'
        }
      },
      manufacturer: {
        '@type': 'Organization',
        name: productData.manufacturer || 'BC Surface Supply',
        url: 'https://bcsurfacesupply.com'
      }
    };
  } else {
    // Organization structured data
    structuredData = {
      '@context': 'https://schema.org',
      '@type': type,
      name,
      description,
      address: {
        '@type': 'PostalAddress',
        ...address
      },
      telephone,
      url,
      logo,
      areaServed: ['Fort Wayne', 'Indiana', 'Midwest'],
      priceRange: '$$',
      openingHours: 'Mo-Fr 09:00-17:00',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Home Improvement Products',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Countertops',
              description: 'Premium countertops for kitchens and bathrooms'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Sinks',
              description: 'High-quality kitchen and bathroom sinks'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Cabinets',
              description: 'Custom and stock cabinets for kitchens and bathrooms'
            }
          }
        ]
      }
    };
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData; 